export default __webpack_public_path__ + "static/media/walk.a867b750.png";